import { formatDtTime } from "../lib/utils";
import React, { Component } from "react";

const ToLocalTime = ({ time }) => formatDtTime(time);
export default ToLocalTime;